import { object, string } from "yup";

const schema = object().shape({
	email: string().email("Must be a valid email").required("Email is required"),
	password: string().required("Password is required"),
	type: string().required("Please select a user type").oneOf(["user", "admin"]),
});

export default schema;
